import localDB from "./localDB";
let GLOBAL = require('./globals');

const LocalData = {
    async products(page=1) {
        await fetch(`${GLOBAL.BASE_URL}api/products-local?page=${page}`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken()
            }
        })
            .then((response) => response.json())
            .then((data) => {
                localDB.updateList('products', data.results);
                if(data.number !== data.total_pages){
                    this.products(data.number+1)
                }
            });
    },
    async clients(page=1) {
        await fetch(`${GLOBAL.BASE_URL}api/clients-local?page=${page}`, {
            method: 'GET',
            headers: { 'Authorization': localDB.sessionToken() }
        })
            .then((response) => response.json())
            .then((data) => {
                localDB.updateList('clients', data.results);
                if(data.number !== data.total_pages){
                    this.clients(data.number+1)
                }
            });
    },
    async providers(page=1) {
        await fetch(`${GLOBAL.BASE_URL}api/providers-local?page=${page}`, {
            method: 'GET',
            headers: { 'Authorization': localDB.sessionToken() }
        })
            .then((response) => response.json())
            .then((data) => {
                localDB.updateList('providers', data.results);
                if(data.number !== data.total_pages){
                    this.providers(data.number+1)
                }
            });
    },
    async ingredients(page=1) {
        await fetch(`${GLOBAL.BASE_URL}api/ingredients-local?page=${page}`, {
            method: 'GET',
            headers: { 'Authorization': localDB.sessionToken() }
        })
            .then((response) => response.json())
            .then((data) => {
                localDB.updateList('ingredients', data.results);
                if(data.number !== data.total_pages){
                    this.ingredients(data.number+1)
                }
            });
    },
};

export default LocalData;


// WEBPACK FOOTER //
// ./src/data/LocalData.js